<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" v-bind:class="className">
      <div class="modal-overlay" @click="back()"></div>
      <div class="modal">
        <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_layers"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Brand <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                      <notice-published v-model="resource" label-published="Ce produit est actif." label-unpublished="Ce produit est inactif." :dates="true"></notice-published>

                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail de la marque</h3>
                                <p class="headline"></p>

                                <form-file label='Logo' v-model="resource.picture_id" width="200"></form-file>

                                <form-gallery label="" v-model="resource.medias" width="200"></form-gallery>

                                <form-toggle label="Show in menu" v-model="resource.is_visible"></form-toggle>

                                <form-toggle label="Show in filters" v-model="resource.is_filterable"></form-toggle>

                                <form-text :label="'Slug'" v-model="resource.slug" :required="true"></form-text>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :lang="client.id" :translate-key="'website'" :translations="resource.translations" label="Lien (URL) de la marque" v-model="resource.translations[client.id].website" :required="false"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'headline'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].headline" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-html :lang="client.id" :translate-key="'description'" :translations="resource.translations" label="Content" v-model="resource.translations[client.id].description" :required="true"></form-html>
                                  </div>
                                </div>

                                <component-attributes v-model="resource"></component-attributes>

                              </fieldset>

                            </tab>
                            <tab name="Collections">

                              <modal
                                  v-model="brandLine"
                                  v-if="isModalVisible"
                                  @close="closeModal"
                                  @validate="validateModal"/>

                              <fieldset>
                                <h3>Collections</h3>


                                <div class="datagrid">
                                    <div class="datagrid-header">
                                        <div>
                                            <div></div>
                                            <div class="picture"></div>
                                            <div><span>Nom</span></div>
                                            <div><span>Référence</span></div>
                                            <div><span>Highlight</span></div>
                                            <div><span>Défault</span></div>
                                            <div class="actions"></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <draggable v-model="resource.lines" @start="drag=true" @end="drag=false" :options="{handle:'.drag'}" class="datagrid-body">
                                        <div v-for="(value, index) in resource.lines" v-show="resource.lines" v-bind:class="{deleted:value.deleted}">
                                            <div></div>
                                            <div class="picture">
                                                <figure>
                                                    <i v-if="!value.picture" class="icon icon-icon_voucher"></i>
                                                    <img v-if="value.picture" :src="value.picture.url+'/fit/100x100'"/>
                                                </figure>
                                            </div>
                                            <div>
                                                <strong>{{ value.translations[locale].name }}</strong>
                                                <p>{{ value.translations[locale].headline }}</p>
                                            </div>
                                            <div>{{ value.slug }}</div>
                                          <div>
                                            <div style="text-align: center;">
                                              <input type="checkbox" name="highlight" v-model="value.is_highlighted" :value="1" @change="updateHighlightedBrandline(index)"/>
                                            </div>
                                          </div>
                                            <div>
                                                <div style="text-align: center;">
                                                    <input type="radio" name="default" v-model="value.is_default" :value="1" @change="updateDefaultBrandline(index)"/>
                                                </div>
                                            </div>
                                            <div class="actions">
                                                <ul>
                                                    <li><button @click="removeValue(value)"><icon name="trash-01"/></button></li>
                                                    <li><button @click="editValue(value)"><icon name="pencil-02"/></button></li>
                                                </ul>
                                                <span @click="cancelDeletedValue(value)" class="undo" v-if="value.deleted">Undo remove</span>
                                            </div>
                                            <div class="drag">
                                                <i class="icon icon-drag"></i>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>

                                <div class="footer-buttons">
                                  <button-action type="create" label="Ajouter une collection" @callback="addBrandline()" />
                                </div>

                              </fieldset>

                            </tab>
                            <tab name="Seo">

                              <fieldset>
                                <h3>SEO</h3>
                                <p class="headline">Optimiser l'affichage de votre produit dans la recherche Google.</p>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :lang="client.id" :translate-key="'meta_url'" :translations="resource.translations" :label="'Url'" v-model="resource.translations[client.id].meta_url"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :lang="client.id" :translate-key="'meta_title'" :translations="resource.translations" :label="'Meta-Title'" v-model="resource.translations[client.id].meta_title"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-textarea :lang="client.id" :translate-key="'meta_description'" :translations="resource.translations" :label="'Meta-Description'" v-model="resource.translations[client.id].meta_description"></form-textarea>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import BrandService from './BrandService.js';
    import Edit from '../../../layouts/Edit.vue';
    import Modal from './Modal.vue'

    import ComponentAttributes from "../../../components/Attributes.vue";


    export default {
        extends: Edit,
        components: {
            Modal,
            'component-attributes': ComponentAttributes,
        },
        data () {
            return {
                brandLine: {data:null},
                options: [],
                templates: null,
                invoice_template_id: null,
                resource: {
                    lines: []
                },
                isModalVisible: false
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description','headline','website','meta_url','meta_title','meta_description']);
                if( this.resource.lines ){
                    for( var i=0; i<this.resource.lines.length ; i++){
                        this.setTranslationsTo(this.resource.lines[i], ['name','headline','description','website','meta_url','meta_title', 'meta_description']);
                        this.resource.lines[i].deleted = 0
                    }
                }else{
                    this.resource.lines = []
                }

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.initialize()
            },
            getResource: function(){
                return BrandService
            },
            beforeUpdate: function(Resource){

                let medias = [];
                if( Resource.medias ){
                    for(let item of Resource.medias){
                        medias.push(item.id);
                    }
                }
                Resource.medias = medias

                return true;

            },
            updateHighlightedBrandline: function(index){
              console.log("update", index);
              //let checked = this.resource.lines[index].is_highlighted;
              //this.resource.lines[index].is_highlighted = checked;
            },
            updateDefaultBrandline: function(index){
                console.log("update", index);
                let checked = this.resource.lines[index].is_default;
                for( var i=0; i<this.resource.lines.length ; i++){
                    this.resource.lines[i].is_default = false;
                }
                this.resource.lines[index].is_default = checked;
            },
            addBrandline: function(){
                var data = {
                    id: null,
                    actionIdent: null,
                    slug: "",
                    publication_state_id: false,
                    picture_id: null,
                    is_default: 0,
                    deleted: 0
                };
                this.setTranslationsTo(data, ['name','headline','description','website','meta_url','meta_title', 'meta_description']);
                //this.resource.lines.push(data);

                this.brandLine.data =  data
                this.isModalVisible = true
            },
            removeValue: function(value){
                value.deleted = 1
                this.$forceUpdate();
            },
            cancelDeletedValue: function(value){
                value.deleted = 0
                this.$forceUpdate();
            },
            editValue(item) {
                item.actionIdent = item.id || item.slug || null;
                this.brandLine.data =  JSON.parse(JSON.stringify(item))
                this.isModalVisible = true
            },
            closeModal() {
                this.isModalVisible = false;
            },
            validateModal() {

              if( this.brandLine.data.slug == "" ){
                  alert("slug empty !")
                  return false;
              }

              let item = this.brandLine.data;
              let exist = -1;
              for( var i=0; i<this.resource.lines.length ; i++){
                if( item.actionIdent != null &&
                    (item.actionIdent === this.resource.lines[i].id || item.actionIdent === this.resource.lines[i].slug)
                ){
                  exist = i;
                }
              }

              let doublon = this.resource.lines.filter(function (o) {
                return (o.id == item.id || o.slug == item.slug) && (item.actionIdent != o.id && item.actionIdent != o.slug);
              }).length > 0;

              if( doublon ){
                alert("slug or id already exists")
                return false;
              }

              if( exist === -1 ){
                this.resource.lines.push(JSON.parse(JSON.stringify(this.brandLine.data)));
              }else{
                this.resource.lines[exist] = this.brandLine.data;
              }

              /*
              let exist = -1;
              for( var i=0; i<this.resource.lines.length ; i++){
                  if( this.brandLine.data.id != null && this.brandLine.data.id === this.resource.lines[i].id ){
                      exist = i;
                  }
              }

              // Check Slug
              for( var i=0; i<this.resource.lines.length ; i++){
                if( this.brandLine.data.slug == this.resource.lines[i].slug && this.brandLine.data.id !== this.resource.lines[i].id ){
                  alert("The reference (slug) exists !")
                  return false;
                }
              }


              if( exist === -1 ){
                this.resource.lines.push(JSON.parse(JSON.stringify(this.brandLine.data)));
              }else{
                this.resource.lines[exist] = this.brandLine.data;
              }
               */

              //this.resource.lines.push(JSON.parse(JSON.stringify(this.brandLine.data)));

              this.closeModal()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/brand/Edit.vue